const it = {
    translation: {
        "W_SAVE": "Salva",
        "W_INSERT": "Inserisci",
        "W_UPDATE": "Modifica",
        "W_DELETE": "Cancella",
        "W_DATE": "Data",
        "W_HOUR": "Ora",
        "W_COPY": "Copia",
        "W_CAROUSEL": "Carosello",
        "W_FEED": "Feed",
        "W_REVIEWS": "Recensioni",
        "W_VERIFIED": "Verificato da",
        "W_VERIFIED_F": "Verificate da",
        "WD_FEED_001": "Mostra piú recensioni",
        "WD_CARO_001": "Vedi tutte le recensioni",
        "W_POWERED": "Powered by",
        "W_SEND": "Invia",
        "W_DATE_FROM": "Data iniziale",
        "W_DATE_TO": "Data finale",
        "W_INTEGRATE": "Integra",
        "W_CHOOSE": "Seleziona la pagina da collegare",
        "W_CHOOSE_G": "Seleziona l'attività da collegare",
        "W_INTEGRATE_FB": "Login con Facebook",
        "W_INTEGRATE_G": "Login con Google",
        "W_DISCONNECT": "Sconnetti",
        "W_SEARCH": "cerca",
        "W_WARNING": "Attenzione",
        "W_CONFIRM": "Conferma",
        "W_BACK": "Indietro",
        "W_EMAIL": "Email",
        "W_NUMBER": "Numero",
        "W_DAYS": "Giorni",
        "W_DAY": "Giorno",
        "W_DAYS_AGO": "Giorni fa",
        "W_DAY_AGO": "Giorno fa",
        "W_TODAY": "Oggi",
        "W_ON": "su",
        "W_YOURPAGE": "latuapagina",
        "W_YOURAPP": "latuaapp",
        "W_INF":"Illimitati",
    }
}
export default it
